import { all } from "redux-saga/effects";
import authSaga from "../authSaga";
import oemSaga from "../oemSaga";
import revenueSaga from "../revenueSaga";
import transactionSaga from "../transactionSaga";
import couponSaga from "../couponSaga";
import oemScanSaga from "../oemScanSaga";
import scanSaga from "../scanSaga";
import dashboardSaga from "../dashboardSaga";
import profileSaga from "../profileSaga";
import countrySaga from "../countrySaga";
import oemscanlistSaga from "../oemscanlistSaga";


export default function* rootSaga() {
  yield all([
    authSaga(),
    oemSaga(),
    revenueSaga(),
    transactionSaga(),
    couponSaga(),
    oemScanSaga(),
    scanSaga(),
    dashboardSaga(),
    profileSaga(),
    countrySaga(),
    oemscanlistSaga(),
  ]);
}
